import React, { Component } from "react";

/**
 * <InviteableList inviteables={Array<obj>}
        syllabi={Array<obj>}
        syllabiSelection={id}
        sylEventIds={Array<obj>}
        universities={Array<obj>}
        universitiesSelection={String}
        addedKey={String}
        matchKey={String}
        bulkAddInvitees={Func}
        fetchUsers={Func}
        handleAddSyl={Func}
        handleDropdownChange={Func}
        handleInvite={Func}
        toggleTrueFalse={Func}
    />
 *
**/
const InviteableList = (props) => {
  const canAddSyl =
    props.syllabiSelection != "" &&
    props.sylEventIds.indexOf(props.syllabiSelection) === -1;
  const inviteables = props.inviteables.map((user, i) => {
    let info = user.full_name + " (" + user.email + ")";
    let hide = user[props.addedKey] || !user[props.matchKey];
    return hide ? (
      ""
    ) : (
      <li
        key={"invtble-" + i}
        className="list-group-item list-group-item-action"
        onClick={() => {
          props.handleInvite(i);
        }}
      >
        {info}
      </li>
    );
  });
  const sylOpts = props.syllabi.map((syl, i) => {
    let cc = syl["course_code_a"].replaceAll(",", "");
    let cn = syl["course_name"];
    let label = cc + " " + cn;
    return label == " " ? (
      ""
    ) : (
      <option key={"sylopt-" + i} value={syl["id"]}>
        {label}
      </option>
    );
  });
  /** ADD COURSE BUTTON **/
  const addSylBtn = canAddSyl ? (
    <button className="btn btn-primary" onClick={props.handleAddSyl}>
      Add Course
    </button>
  ) : (
    <button className="btn btn-primary disabled">Add Course</button>
  );
  const univOpts = props.universities.map((univ, i) => {
    let univName = univ["name"];
    return (
      <option key={"univopt-" + i} value={univ["id"]}>
        {univName}
      </option>
    );
  });
  return (
    <div className="card inner-buffer w-50 alert alert-secondary">
      <div>
        <h5>
          <a
            className="btn btn-link text-danger col-1 p-1 text-decoration-none"
            onClick={() => {
              props.toggleTrueFalse("selecting_invitees");
            }}
          >
            <h4>
              <strong>x</strong>
            </h4>
          </a>
          Add Invitees and Courses For This Event
        </h5>
        <div className="pb-0 mb-0">
          <strong>
            <label htmlFor="university-filter">Select University:</label>
          </strong>
        </div>
        <div className="btn-group mb-1">
          <select
            id="university-filter"
            className="btn btn-secondary"
            style={{ width: "25vw" }}
            onChange={(e) => {
              props.handleDropdownChange("universities_selection", e);
            }}
          >
            <option value="">--ALL USERS--</option>
            {univOpts}
          </select>
        </div>
        <div className="pb-0 mb-0">
          <strong>
            <label htmlFor="syllabi-filter">Select Course:</label>
          </strong>
        </div>
        <div className="btn-group mb-1">
          <select
            id="syllabi-filter"
            className="btn btn-secondary"
            style={{ width: "25vw" }}
            onChange={(e) => {
              props.handleDropdownChange("syllabi_selection", e);
            }}
          >
            <option value="">--ALL USERS--</option>
            {sylOpts}
          </select>
          <button className="btn btn-secondary" onClick={props.fetchUsers}>
            Show People
          </button>
        </div>
        <div className="btn-toolbar mb-1">
          <button className="btn btn-primary" onClick={props.bulkAddInvitees}>
            Bulk Add Users
          </button>
          {addSylBtn}
        </div>
      </div>
      <div
        className="card p-3"
        style={{ maxHeight: "100vh", overflow: "scroll" }}
      >
        {inviteables}
      </div>
    </div>
  );
};

export default InviteableList;
